import { render } from "./Claim_2_Reassessment_approvedBillList.vue?vue&type=template&id=38c217c2&scoped=true&ts=true"
import script from "./Claim_2_Reassessment_approvedBillList.vue?vue&type=script&lang=ts"
export * from "./Claim_2_Reassessment_approvedBillList.vue?vue&type=script&lang=ts"

import "./Claim_2_Reassessment_approvedBillList.vue?vue&type=style&index=0&id=38c217c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c217c2"]])

export default __exports__